<template>
  <div>
    <CContainer>
      <CRow class="mt-4">
        <CCol md="12" class="d-flex align-items-center justify-content-center">
          <h1 class="mb-4">Modules List</h1>
        </CCol>
        <CCol lg="8" sm="12" class="modulesList">
          <div>
            <appointment-pass-module-form v-if="isAppPassAval" />
          </div>
          <div>
            <tardy-management-module-form v-if="isTardyCheckInAval" />
          </div>
          <div>
            <kiosk-module-form v-if="isKioksAval" />
          </div>
          <div>
            <auto-check-in-module-form v-if="isAutoCheckInAval" />
          </div>
          <div>
            <digital-id-card-form></digital-id-card-form>
          </div>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import AppointmentPassModuleForm from "../components/Forms/AppointmentPassModuleForm"
import AutoCheckInModuleForm from "../components/Forms/AutoCheckInModuleForm"
import KioskModuleForm from "../components/Forms/KioskModuleForm"
import DigitalIdCardForm from "../components/Forms/DigitalIdCardForm"
import TardyManagementModuleForm from "../components/Forms/Tardy/TardyManagementModuleForm"
import { mapGetters } from "vuex"

export default {
  name: "ModulesList",
  components: {
    KioskModuleForm,
    AutoCheckInModuleForm,
    AppointmentPassModuleForm,
    DigitalIdCardForm,
    TardyManagementModuleForm
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      availableSchoolModules: "schools/availableSchoolModules"
    }),
    isKioksAval() {
      return (
        this.availableSchoolModules &&
        this.availableSchoolModules.includes("Kiosk")
      )
    },
    isAppPassAval() {
      return (
        this.availableSchoolModules &&
        this.availableSchoolModules.includes("Appointmentpass")
      )
    },
    isAutoCheckInAval() {
      return (
        this.availableSchoolModules &&
        this.availableSchoolModules.includes("Auto Check-In")
      )
    },
    isTardyCheckInAval() {
      return (
        this.availableSchoolModules &&
        this.availableSchoolModules.includes("Tardy Management")
      )
    }
  }
}
</script>
